import React from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import { IconBrandWalmart } from "@tabler/icons-react";
import { Message } from "../../interfaces";
interface Props {
  message: Message;
  type: string;
}

const ChatMessageTimestamp: React.FC<Props> = ({ message, type }) => {
  const { isManual, isAd, adUrl, isFollowUp, timestamp, status, svg, right } =
    message;
  return (
    <span className="chat-item-time">
      {isManual && type === "conversation" && (
        <span className="color-step-500">
          <FormattedMessage id="chats.enabled" /> - {message.email}{" "}
        </span>
      )}
      {isFollowUp && type === "conversation" && (
        <span className="color-step-500">
          <IconBrandWalmart size={12} />{" "}
          <FormattedMessage id="chats.followUp" />{" "}
        </span>
      )}
      {isAd && adUrl && (
        <span>
          <FormattedMessage id="chats.ad" />:{" "}
          <a href={adUrl} target="_blank">
            {adUrl}
          </a>{" "}
        </span>
      )}
      {type !== "debug" && <span className="color-step-500">{timestamp}</span>}
      {right && type === "conversation" && (
        <svg
          viewBox="0 0 16 11"
          height="11"
          width="16"
          preserveAspectRatio="xMidYMid meet"
          className={classNames("", {
            read: status === "read",
            failed: status === "failed",
          })}
          fill="none"
        >
          <path d={svg} fill="currentColor" />
        </svg>
      )}
    </span>
  );
};

export default ChatMessageTimestamp;
